import classes from './dropDown/cppDropDown.scss';
import SceDropDown from './dropDown/cppTextDropDown';
import AddTextDialogBox from './dropDown/addTextDialogBox';
import EditTextDialogBox from './dropDown/editTextDialogBox';
import SceButton from '../../../../../../../Common/CommonComponents/sceButton';
import DeleteTextNumberDialog from './deletePhoneNumberDialog';
import { getLocalizedStrings } from './dropDown/manageAlertPreferencesDropdownString';
import NotificationHelper from './dropDown/notificationHelper';

class SetUpTextDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.strings = getLocalizedStrings('mobileText');
    this.state = {
      additionalInfoStateOpen: [false, false, false],
      addTextMessageDialog: false,
      textPlaceholder: 'Select Phone Number',
      newTextNo: '',
      editTextMessageDialog: false,
      deleteTextNumberDialog: false,
      addTextMessageNum: { value: '', isError: false, isValidated: false, errorMsg: '', forceValidate: false, encryptedPhoneNumber:"", },
      editTextMessageNum: { value: '', isError: false, isValidated: false, errorMsg: '', forceValidate: false, encryptedPhoneNumber:"" },
      Text: this.props.dropDownData.mobileSet,
      selectedTextNo: !_.isEmpty(this.props.premiseData.preferText) ? this.props.premiseData.preferText : 'No text alerts',
      editVal: '',
      businessPatner:this.props.businessPartner,
      addOptions: ['Landline', 'Mobile'],
      editOptions: ['Landline', 'Mobile'],
      selectedOptions: '', radioErrorState: false, validateRadioInputsForcibly: false, selectedOptionValidStyle: '', radioOutline: '',
      showHintMessage: false,
      showLoadingIndicator: false,
      isLocalError: false, deleteEncValue:"",
      placeholder:!_.isEmpty(this.props.selectedValue) ? this.props.selectedValue : 'Enter Phone',
    };
  }

  componentWillMount() {
    this.getTextList(this.state.Text);
  }
  componentWillReceiveProps(nextProps) {
    this.getTextList(nextProps.dropDownData.mobileSet);
  }
  getTextList(textList) {
    let that = this;
    let selectedText = textList.filter((text) => {
      return text.value !== 'addText';
    });
    let textValueArr = selectedText.map((obj)=>obj.telephoneNumber);
    // selectedText = selectedText.filter((item, i)=>{
    //   return textValueArr.indexOf(item.telephoneNumber) === i;
    // });
    let selectBoxTextList = selectedText.map(function (text, index) {
      let telephoneNumber = NotificationHelper.formatPhoneNumWithStar(text.telephoneNumber);
      let textUI = <div>
            <span className={classes.sceEmailwrap}>
                <span className={classes.scePhoneListStyle} >{telephoneNumber} </span>
                {text.standardIndicatorText === "X" ?
                <span className={'pull-right ' + classes.sceEmailDelete + " " + classes.sceTooWrap} id={telephoneNumber + '_' + index} index={index}>
                    <span className={classes.sceQuestion}>?</span> <span className={classes.sceTooltip}> {that.strings.textTooltip} </span> 
                </span> 
                : 
                <span className={classes.scePhoneAlign}> 
                  <span className={classes.scePhoneStyle}>
                    <span id={'deleteChild_'+telephoneNumber + '_' + index + that.props.id+ that.props.dropdownDiffererentiator} index={index} onClick={() => that.onDeleteTextDialogClick()} className={'pull-right ' + classes.sceDelete + " " + classes.scePhoneBtn}>Delete</span>
                    <span id={'modifyChild_'+telephoneNumber + '_' + index + that.props.id+ that.props.dropdownDiffererentiator} index={index} onClick={() => that.onEditTextDialogClick()} className={'pull-right ' + " " + classes.scePhoneBtn}>Modify</span>
                  </span>
                </span>
              }
            </span>
        </div>;

      return {
        name: telephoneNumber, modifiedName: textUI, value: telephoneNumber, encryptedPhoneNumber: text.encryptedPhoneNumber, type: text.type, indicatorSmsEnabled: text.indicatorSmsEnabled, indicatorTelephone: text.indicatorTelephone
      };
    });
    
    this.setState({ Text: selectBoxTextList }, () => { });
  }
  onAddTextMessageDialogClick = () => { this.setState(...this.state, { addTextMessageDialog: !this.state.addTextMessageDialog }); }
  onAddPhoneConfirmDialogClick = (e,name,value,encVal) => {
    this.props.onModifyCustomerPreference('text', encVal, value);    
  }
  onConfirmTextDialog = (deleteValue) => { this.setState(...this.state, { confirmDeleteTextDialog: !this.state.confirmDeleteTextDialog }); }
  onEditTextDialogClick = () => { 
    this.setState(...this.state, { editTextMessageDialog: !this.state.editTextMessageDialog }); 
  }
  onDeleteTextDialogClick = () => {
    this.setState(...this.state, { deleteTextNumberDialog: true});
  }
  onDeleteCancelClickHandler = (e) => {
    e.preventDefault();
    this.setState(...this.state, { deleteTextNumberDialog: false});
  }
  onEditTextMessageConfirmDialogClick = () => {
    /***********************
    Change type : Security changes for phone numbers
    Changed by: Sai Aman Pothuganti
    Date : 06-10-2020
    ************************/
    var updatedState = {...this.state};
    if(updatedState.editTextMessageNum.isError || updatedState.showLoadingIndicator) return;
    var editTextMessageNum = updatedState.editTextMessageNum.encryptedPhoneNumber;
    var existingTextPreference = updatedState.Text.filter(item=> item.encryptedPhoneNumber === editTextMessageNum);
    updatedState.editTextMessageNum.isError = existingTextPreference.length>0 ? true : false;
    updatedState.editTextMessageNum.errorMsg = updatedState.editTextMessageNum.isError ? 'Preference already existing' : '';
    !updatedState.editTextMessageNum.isError ? updatedState.editTextMessageDialog = false : null;
    updatedState.editTextMessageNum.isError ? this.setState(updatedState) : 
    this.setState(updatedState, () =>{
      this.props.onModifyCustomerPreference('text', editTextMessageNum, updatedState.editTextMessageNum.value);
    });
  }
  onDeleteTextConfirmDialogClick = (e) => {
    this.props.onModifyCustomerPreference('text', this.state.deleteEncValue, this.state.deleteValue);
  }

  retrievedataFromTextBoxes = (data) => {
    /***********************
    Change type : Security changes for phone numbers
    Changed by: Sai Aman Pothuganti
    Date : 06-10-2020
    ************************/
    if(data.id === "addTextMessageNum" ) {
      this.setState({ ...this.state, addTextMessageNum: { ...this.state.addTextMessageNum, isError: data.isError, value: data.value, encryptedPhoneNumber:data.encNum, errorMsg:data.isError?"Please enter valid number.":"" }, isLocalError:false }, ()=>{
        !data.isError ? this.getEncryptedNumber(data.id, data.value) : null;
      });
    }
    else{
      this.setState({ ...this.state, editTextMessageNum: { ...this.state.addTextMessageNum, isError: data.isError, value: data.value, encryptedPhoneNumber:data.encNum, errorMsg:data.isError?"Please enter valid number.":"" }, isLocalError:false }, ()=>{
        !data.isError ? this.getEncryptedNumber(data.id, data.value) : null;
      });
    }
  }
  handleTextClick = (data) => {
    var selectedPhone,selectedOptions;
    this.props.data.mobileSet.map((phone)=>{
      if(phone.encryptedPhoneNumber === data.encNum){
        selectedPhone={...phone};
      }
    });
    if(selectedPhone && (selectedPhone.indicatorTelephone==='' || selectedPhone.indicatorTelephone==='1')) selectedOptions='Landline';
    else if(selectedPhone && (selectedPhone.indicatorTelephone==='2' || selectedPhone.indicatorTelephone==='3')) selectedOptions='Mobile';
    this.setState({ deleteValue: data.value, deleteEncValue:data.encNum, selectedOptions:selectedOptions || '', selectedOptionValidStyle: selectedOptions || '', radioOutline: selectedOptions || ''});
    if (data.value === 'addText') {
      this.onAddTextMessageDialogClick();
    }else if(data.modifyChild === 'modifyChild'){
      this.onEditTextDialogClick();
    }else if(data.modifyChild === 'deleteChild'){
      this.onDeleteTextDialogClick();
    }else {
      this.setState({ newTextNo: data.value }, () => this.onSelectDropDown(data));
    }
  }
  onMobileRadioClick = (e, keys) => {
    let newArr = (this.state.additionalInfoStateOpen).map((value, index) => {
      return (index === keys);
    });
    let updatedState = { ...this.state }, isConfirmDisabled = false ;
    //updatedState.editTextMessageNum.value === '' ? updatedState.editTextMessageNum.value = updatedState.deleteValue : null;
    updatedState.selectedOptions = e.target.value;
    //isConfirmDisabled = DropDownHelper.getEditTextConfirmDisabledStatus(updatedState.editTextMessageNum.value, updatedState.deleteValue, updatedState.Text, updatedState.selectedOptions);
    this.setState({
      removeRadioButton: true, selectedOptions: e.target.value, validateRadioInputsForcibly: false, validateTextInputsForcibly: false, hasTextInputsError: false, clearTextElements: true, radioErrorState: false, additionalInfoStateOpen: newArr, radioOutline: e.target.value,
      selectedOptionValidStyle: e.target.value, editTextMessageNum:{...this.state.editTextMessageNum, errorMsg:'', isError:false}
    });
  }

  onRadioFocus = (e, keys) => {
    let newArr = (this.state.additionalInfoStateOpen).map((value, index) => {
      return (index === keys);
    });
    this.setState({ additionalInfoStateOpen: newArr });
  }
  onCancelClickHandler = (e) => {
    e ? e.preventDefault() : null;
    this.setState({
      ...this.state, deleteTextDialog: false, confirmDeleteTextDialog: false, addTextMessageDialog: false, editTextMessageDialog: false, editTextMessageNum: { value: '', isError: false, isValidated: false, errorMsg: '', forceValidate: false,  isDisabled: true, }
    }, () => {});
  }
  onSelectDropDown = (e) => {
    var reqObj={...e};
    reqObj.id=this.props.id;
    this.props.onSelectDropDown(reqObj);
  }
  render() {
    return (
      <div>
        {this.state.deleteTextNumberDialog ?
          <DeleteTextNumberDialog
          onConfirmDeletePhoneDialogClick={this.onDeleteTextConfirmDialogClick}
            deleteValue={this.state.deleteValue}
            onCancelClickHandler={this.onDeleteCancelClickHandler}
          /> : null}
        <div className={classes.scePhoneNumber}>
          <SceDropDown id={'textNumberSelection_' +this.props.id+this.props.dropdownDiffererentiator}
            selectBoxData={this.state.Text}
            contactType={"text"}
            placeholder={this.state.placeholder}
            validator={app.appUtil.validator}
            handleClick={this.handleTextClick}
            ariaLabel='textNumberSelectBox'
            errorMessage={this.props.isDropDownError ? 'Please select phone number' : this.props.isSameValueError ? 'Primary and Secondary Contact details cannot be same.':''}
            selectErrorMessage={'Please select phone number'}
            onDoneEnabledButton={this.props.onDoneEnabledButton}
            onAddTextMessageDialogClick={this.onAddTextMessageDialogClick}
            onDeleteTextDialog={this.onDeleteTextDialog}
            onEditTextDialogClick={this.onEditTextDialogClick}
            defaultText={this.state.textPlaceholder}
            data={this.state.data}
            isError={this.props.isDropDownError || this.props.isSameValueError}
            triggerOnClick={this.props.triggerOnClick}
            onAddPhoneConfirmDialogClick={this.onAddPhoneConfirmDialogClick}
            inputButtonText={this.props.inputButtonText}
            addContactEncValueArr={this.props.addContactEncValueArr}


          />

          {/* <div className={'row ' + classes.sceBtnWrap}>
            <div className={'col-xs-12 col-sm-6'}>
              <SceButton id={'cancelTextButton_'+this.props.id+this.props.dropdownDiffererentiator} buttonType='sceCancel' iconType='cancel' iconPosition='right' value='Cancel' responive='false' onClick={this.props.triggerOnClick} />
            </div>
          </div> */}

          {this.state.addTextMessageDialog ?
            <AddTextDialogBox
              onAddTextMessageDialogClick={this.onAddTextMessageDialogClick}
              retrievedataFromTextBoxes={this.retrievedataFromTextBoxes}
              addTextMessageNum={this.state.addTextMessageNum}
              options={this.state.addOptions}
              selectedOptions={this.state.selectedOptions}
              selectedOptionValidStyle={this.state.selectedOptionValidStyle}
              radioOutline={this.state.radioOutline}
              onMobileRadioClick={this.onMobileRadioClick}
              onRadioFocus={this.onRadioFocus}
              onCancelClickHandler={this.onCancelClickHandler}
              onAddTextMessageConfirmDialogClick={this.onAddTextMessageConfirmDialogClick}
              isLocalError={this.state.isLocalError}
              showSpinner={this.state.showLoadingIndicator}
            /> : null}

          {this.state.editTextMessageDialog ? <EditTextDialogBox
            onEditTextDialogClick={this.onEditTextDialogClick}
            onEditTextMessageConfirmDialogClick={this.onEditTextMessageConfirmDialogClick}
            editTextMessageDialog={this.editTextMessageDialog}
            editTextMessageNum={this.state.editTextMessageNum}
            retrievedataFromTextBoxes={this.retrievedataFromTextBoxes}
            selectedOptions={this.state.selectedOptions}
            selectedOptionValidStyle={this.state.selectedOptionValidStyle}
            radioOutline={this.state.radioOutline}
            options={this.state.editOptions}
            onCancelClickHandler={this.onCancelClickHandler}
            onMobileRadioClick={this.onMobileRadioClick}
            deleteValue={this.state.deleteValue}
            isLocalError={this.state.isLocalError}
            showSpinner={this.state.showLoadingIndicator} /> : null}
            
        </div>
      </div>
    );
  }



}

export default SetUpTextDropdown;
